import React, { useEffect, useReducer } from 'react'
import { useSelector } from 'react-redux'
import Loader from 'store/components/Loader'
import { getProducts } from './actions'
import reducer, { initialState } from './reducers'
import style from './index.module.sass'
import Layout from './components/Layout'

const FavoritesPage = () => {
  const [{
    products,
    isLoaded,
    isLoading,
    errors,
  }, localDispatch] = useReducer(reducer, initialState)

  const { productIds } = useSelector((state) => ({
    productIds: state.favorite.products,
  }))

  useEffect(() => {
    if (productIds.length) {
      getProducts(localDispatch)
    }
  }, [localDispatch, productIds])

  const loading = isLoading && !isLoaded

  if (loading) return <Loader containerClassName={style.loadingContainer} />

  if (errors) {
    return (
      <div>
        {errors}
      </div>
    )
  }

  return productIds.length ? <Layout products={products} /> : (
    <div className={style.favoritesEmpty}>
      <div className={style.header}>
        В избранном пока ничего нет
      </div>
    </div>
  )
}

export default FavoritesPage
